export default __webpack_public_path__ + "static/summer_containers18-ac9eaf84c15b7bafba360511fadb5091.webp";